export const LOCALES = ["en", "ar"] as const;
export type Locale = (typeof LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

// Gulf Cooperation Council — visitors here get a soft Arabic default.
// ISO-3166 alpha-2, matched against Vercel's x-vercel-ip-country header.
export const GCC_COUNTRIES = new Set(["SA", "AE", "KW", "QA", "BH", "OM"]);

// Crawler exemption: bots must never be geo-switched, or /ar may go unindexed.
const BOT_RE =
  /bot|crawl|spider|slurp|bingpreview|googlebot|duckduckbot|baiduspider|yandex|facebookexternalhit|embedly|quora link preview|whatsapp|telegrambot/i;
export function isBot(userAgent: string | null): boolean {
  return !!userAgent && BOT_RE.test(userAgent);
}

export function localeForCountry(country: string | null): Locale {
  return country && GCC_COUNTRIES.has(country) ? "ar" : "en";
}
